/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, createContext, useContext, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

export const StateContext = createContext(null);

export default function RangePlanProductListingProvider({ children, ...props }) {
  const reducer = useSelector((reducerstate) => reducerstate);
  const { ProductListData } = reducer;
  const { rangePlanProductInfo } = ProductListData;
  const initialSetting = {
    loader: false,
    rangeProductInfoList: [],
    productsList: [],
    productsNumber: 0,
    manualList: [],
    productFields: [],
    selectedSection: null,
    selectedProductGroup: null,
    RPActiveTab: 'product-info',
    mainLoader: false,
    isNoteVisible: false,
    notes: '',
    bomCustomAttributeColumns: [],
  };

  const [rangePlanProvider, setRangePlanProvider] = useState(initialSetting);
  const [lengthEnabled, setLengthEnabled] = useState(true);

  useEffect(() => {
    /* Only the BOM tab response carries this key; every other tab must leave the columns untouched. */
    const bomColumns = rangePlanProductInfo?.data?.bomCustomAttributeColumns;
    const bomColumnsUpdate = Array.isArray(bomColumns) ? { bomCustomAttributeColumns: bomColumns } : {};
    if (rangePlanProductInfo && rangePlanProductInfo?.data?.doc?.length > 0) {
      setRangePlanProvider((prevState) => ({
        ...prevState,
        ...bomColumnsUpdate,
        productsList: [...(rangePlanProvider?.productsList || []), ...(rangePlanProductInfo?.data?.doc || [])],
        productsNumber: rangePlanProductInfo?.data?.totalCount,
      }));
    } else {
      setRangePlanProvider((prevState) => ({
        ...prevState,
        ...bomColumnsUpdate,
        productsList: [],
        productsNumber: 0,
      }));
    }
  }, [rangePlanProductInfo]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (userData?.lengthVisible !== null && userData?.lengthVisible !== undefined) {
      setLengthEnabled(userData?.lengthVisible);
    }
  }, []);

  const contextValue = useMemo(
    () => ({
      setRangePlanProvider,
      rangePlanProvider,
      lengthEnabled,
    }),
    [setRangePlanProvider, rangePlanProvider, lengthEnabled],
  );
  return <StateContext.Provider value={contextValue}>{children}</StateContext.Provider>;
}

export function useProductListingState() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error('useProductListingState must be used within the RangePlanProductListingProvider');
  }
  return context;
}
